import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchProductById } from "../firebase/fireStoreServices";
import {
  Box,
  Button,
  Chip,
  Container,
  Divider,
  Grid,
  Typography,
  Paper,
  Stack,
} from "@mui/material";

export default function ProductDescription() {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const loadProduct = async () => {
      const data = await fetchProductById(id);
      setProduct(data);
    };
    loadProduct();
  }, [id]);

  if (!product) return <Typography>Loading...</Typography>;

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper
        elevation={4}
        sx={{
          borderRadius: 4,
          p: 4,
          bgcolor: "#fff8f0",
          boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
        }}
      >
        <Grid container spacing={5} alignItems="center">
          {/* Cake Image */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={product.image}
              alt={product.title}
              sx={{
                width: "100%",
                borderRadius: 4,
                boxShadow: 5,
              }}
            />
          </Grid>

          {/* Cake Details */}
          <Grid item xs={12} md={6}>
            <Stack spacing={3}>
              <Typography
                variant="h5"
                fontWeight="bold"
                color="primary"
                textAlign="center"
                sx={{
                  textDecoration: "none",
                  "&:hover": { color: "secondary.main" },
                }}
              >
                {product.title}
              </Typography>
              <Typography
                variant="subtitle1"
                fontStyle="italic"
                textAlign="center"
                sx={{
                  pl: 0,
                  textDecoration: "none",
                  "&:hover": { color: "secondary.main" },
                }}
              >
                {product.subtitle}
              </Typography>

              <Divider />

              <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                <strong>Description: </strong>
                {product.description}
              </Typography>

              <Divider />

              <Stack spacing={1.5}>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  <Chip
                    label={`Category: ${product.category}`}
                    color="primary"
                  />
                  <Chip label={`Flavor: ${product.flavor}`} />
                  <Chip label={`Weight: ${product.weight}`} />
                </Stack>

                <Stack direction="row" spacing={1} flexWrap="wrap">
                  {product.discount > 0 && (
                    <Chip
                      label={`Discount: ${product.discount}% OFF`}
                      color="success"
                    />
                  )}
                </Stack>
              </Stack>

              <Typography variant="h6" color="error" fontWeight={600}>
                <strong>Price: </strong>₹{product.price}
              </Typography>

              {product.occasion && (
                <Typography variant="body2">
                  <strong>Occasion:</strong>{" "}
                  {Array.isArray(product.occasion)
                    ? product.occasion.join(", ")
                    : product.occasion}
                </Typography>
              )}
              {product.ingredients && (
                <Typography variant="body2">
                  <strong>Ingredients:</strong> {product.ingredients}
                </Typography>
              )}
              {product.rating && (
                <Typography variant="body2">
                  <strong>Rating:</strong> {product.rating} ★
                </Typography>
              )}
              {product.reviews && (
                <Typography variant="body2">
                  <strong>Reviews:</strong> {product.reviews}
                </Typography>
              )}
            </Stack>

            {/* Back Button */}
            <Button
              variant="outlined"
              size="large"
              sx={{ mt: 4 }}
              onClick={() => navigate(-1)} // Prefer fixed route over navigate(-1)
            >
              ← Back to Products
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
